import { render, staticRenderFns } from "./SuccessStoryList.vue?vue&type=template&id=788a48ff&scoped=true&"
import script from "./SuccessStoryList.vue?vue&type=script&lang=js&"
export * from "./SuccessStoryList.vue?vue&type=script&lang=js&"
import style0 from "./SuccessStoryList.vue?vue&type=style&index=0&id=788a48ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788a48ff",
  null
  
)

export default component.exports